import {useCallback} from 'react'
import {useNavigate} from 'react-router'

const BASE_PATH = '/connect_payout_account'

const HAPPY_FLOW = [
  'information',
  'yodlee',
  'payout_account',
  'reconciliation_account',
  'confirmation',
]
const FAILURE_FLOW = ['failed', 'get_help', 'support_request_received']

const getFlowForStep = (step) => {
  if (FAILURE_FLOW.includes(step)) return FAILURE_FLOW
  return HAPPY_FLOW
}

export const isLastStep = (step) => {
  const flow = getFlowForStep(step)
  return flow.at(-1) === step
}

const getNextStepRoute = (currentStep) => {
  const flow = getFlowForStep(currentStep)
  const currentIndex = flow.indexOf(currentStep)
  const nextStep = flow[currentIndex + 1]

  if (!nextStep) return null

  return `${BASE_PATH}/${nextStep}`
}

const useStepNavigation = (currentStep) => {
  const navigate = useNavigate()

  const goToNextStep = useCallback(() => {
    const route = getNextStepRoute(currentStep)

    if (route) {
      navigate(route)
    }
  }, [currentStep, navigate])

  const goToReconciliationAccount = useCallback(() => {
    navigate(`${BASE_PATH}/reconciliation_account`)
  }, [navigate])

  const goToConfirmation = useCallback(() => {
    navigate(`${BASE_PATH}/confirmation`)
  }, [navigate])

  const goToSupportRequestReceived = useCallback(() => {
    navigate(`${BASE_PATH}/support_request_received`)
  }, [navigate])

  const goToConnectExpenseAccount = useCallback(() => {
    navigate('/connect_expense_account')
  }, [navigate])

  const goToDashboard = useCallback(() => {
    navigate('/dashboard')
  }, [navigate])

  const onYodleeFailure = useCallback(() => {
    navigate(`${BASE_PATH}/failed`)
  }, [navigate])

  const goToGetHelp = useCallback(() => {
    navigate(`${BASE_PATH}/get_help`)
  }, [navigate])

  const onTryAgain = useCallback(() => {
    navigate(`${BASE_PATH}/yodlee`)
  }, [navigate])

  return {
    goToNextStep,
    goToReconciliationAccount,
    goToConfirmation,
    goToSupportRequestReceived,
    goToConnectExpenseAccount,
    goToDashboard,
    onYodleeFailure,
    onTryAgain,
    goToGetHelp,
  }
}

export default useStepNavigation
